// extracted by mini-css-extract-plugin
module.exports = {"root":"Status_root__3GAHq","approved":"Status_approved__2v9oi","rejected":"Status_rejected__q5RXO","expired":"Status_expired__2B7Ah","label":"Status_label__13uF1"};